export const bookingDateDefaultValues = {
  bookingStartDate: null,
  bookingEndDate: null,
};

export const tripDateDefaultValues = {
  tripStartDate: null,
  tripEndDate: null,
};
